module.exports = __webpack_public_path__ + "assets/GoldKappa.0739dc0055c91db4c199e74ad0e71646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldKappa.png
// module id = 764
// module chunks = 0